import type { Dashboard, DashboardInput, Widget } from '@detect/shared';
import { api, withTenant, type PaginatedResult } from './api';
import type { WithId } from './types';

export const dashboardService = {
  list: (
    tenantId: string,
    params: { scope?: 'shared' | 'mine' | 'all'; limit?: number; startAfter?: string } = {}
  ): Promise<PaginatedResult<WithId<Dashboard>>> =>
    api.getPaginated<WithId<Dashboard>>(withTenant('/dashboards', tenantId, params)),

  get: (tenantId: string, id: string): Promise<WithId<Dashboard>> =>
    api.get<WithId<Dashboard>>(withTenant(`/dashboards/${id}`, tenantId)),

  create: (tenantId: string, input: DashboardInput): Promise<WithId<Dashboard>> =>
    api.post<WithId<Dashboard>>(withTenant('/dashboards', tenantId), input),

  update: (
    tenantId: string,
    id: string,
    patch: Record<string, unknown>
  ): Promise<WithId<Dashboard>> =>
    api.put<WithId<Dashboard>>(withTenant(`/dashboards/${id}`, tenantId), patch),

  clone: (tenantId: string, id: string, name?: string): Promise<WithId<Dashboard>> =>
    api.post<WithId<Dashboard>>(
      withTenant(`/dashboards/${id}/clone`, tenantId),
      name ? { name } : {}
    ),

  remove: (tenantId: string, id: string): Promise<void> =>
    api.delete(withTenant(`/dashboards/${id}`, tenantId)),

  /** One POST per widget: strict per-type config validation server-side. */
  widgetData: <T>(
    tenantId: string,
    request: {
      type: Widget['type'];
      config: Record<string, unknown>;
      startMs?: number;
      endMs?: number;
    }
  ): Promise<T> =>
    api.post<T>(withTenant('/dashboards/widget-data', tenantId), request),
};
